import { IconSvg, IconSvgProps } from "./icon"

export default function ArrowDown(props: IconSvgProps) {
  return (
    <IconSvg {...props}>
      <path d="M12 4.052v16.714M7.5 16.266l4.5 4.5 4.5-4.5" />
    </IconSvg>
  )
}
